<template>
    <div>
        <div class="article-list">
            <div class="article-container">
                <div class="article-title">
                    <div class="name-wrapper">
                        <h3>문제 생성</h3>
                    </div>
                </div>
                <div class="article-demonstrate">
                    <li class="demonstration">문제를 만들어보세요</li>
                </div>
                <div class="article-table">
                    <template v-if="tableData !== null">
                        <el-table
                                :data="questionData"
                                style="width: 100%"
                                size="small"
                                empty-text="문제가 없습니다."
                                cell-style="cursor: pointer">
                            <el-table-column
                                    label="번호"
                                    width="45">
                                <template slot-scope="scope">
                                    {{listCount - scope.$index - (page - 1) * 15}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="학년"
                                    prop="grade"
                                    width="50"
                                    align="left"
                                    header-align="center">
                            </el-table-column>
                            <el-table-column
                                    label="학기"
                                    prop="semester"
                                    width="50"
                                    align="left"
                                    header-align="center">
                            </el-table-column>
                            <el-table-column
                                    prop="name"
                                    label="대단원"
                                    width="230"
                                    header-align="center">
                            </el-table-column>
                            <el-table-column
                                    prop="questionName"
                                    label="소단원"
                                    width="225"
                                    header-align="center">
                            </el-table-column>
                            <el-table-column
                                    label="작성일"
                                    width="90"
                                    align="center">
                                <template slot-scope="scope">
                                    {{scope.row.date.split('T')[0]}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="수정"
                                    width="150"
                                    align="left"
                                    header-align="center">
                                <template slot-scope="scope">
                                    <el-button type="warning" size="mini" @click="modifyQuestion(scope.row.id)">수정</el-button>
                                    <el-button type="danger" size="mini" @click="deleteQuestion(scope.row.id)">삭제</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </template>
                </div>
                <div class="write-buttons">
                    <el-button type="primary" size="small" @click="$router.push('/maker')">문제생성</el-button>
                    <el-button type="primary" size="small" @click="dialogVisible = true" style="margin-right: 10px;">단원생성</el-button>
                </div>
                <div class="pagination">
                    <el-pagination
                            layout="prev, pager, next"
                            @current-change="pagination"
                            :pageSize="15"
                            :total="listCount">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog
                style="text-align: right;"
                :visible.sync="dialogVisible"
                width="700px">
                <el-table
                    height="400"
                    :data="chapterData"
                    style="width: 100%;">
                <el-table-column
                        prop="grade"
                        label="학년"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="semester"
                        label="학기"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="num"
                        label="단원"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="name"
                        label="단원명">
                </el-table-column>
                <el-table-column
                        label="수정"
                        width="160"
                        align="left"
                        header-align="center">
                    <template slot-scope="scope">
                        <el-button type="warning" size="mini" @click="modifyChapter(scope.row.id, scope.$index)">수정</el-button>
                        <el-button type="danger" size="mini" @click="deleteChapter(scope.row.id, scope.$index)">삭제</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-form ref="form" size="mini" :model="form" style="margin-top: 20px;" label-width="120px">
                <el-form-item label="학년">
                    <el-input size="mini" v-model="form.grade"></el-input>
                </el-form-item>
                <el-form-item label="학기/단원" style="text-align: left;">
                    <el-input-number size="mini" v-model="form.semester" :min="1" :max="2" style="margin-right: 20px;"></el-input-number>
                    <el-input-number size="mini" v-model="form.num"></el-input-number>
                </el-form-item>
                <el-form-item label="단원명">
                    <el-input size="mini" v-model="form.name"></el-input>
                </el-form-item>
            </el-form>
            <el-button type="primary" size="small" @click="createChapter()">{{chapterStatus}}</el-button>
        </el-dialog>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        name: "MakerList",
        components: {
        },
        data() {
            return {
                chapterData: [],
                dialogVisible: false,
                form: {
                    grade: 1,
                    semester: 1,
                    num: 1,
                    name: ''
                },
                chapterStatus: '생성',
                questionData: [],
                listCount: 1,
                page: 1
            }
        },
        async created() {
            this.chapterData = (await this.$http.get(`/api/chapters/list`)).data
            this.getList(this.page)
        },
        mounted() {
        },
        methods: {
            async deleteQuestion(idx) {
                if (confirm('정말 삭제하시겠습니까?')) {
                    await this.$http.post(`/api/questions/delete`, {id: idx})
                    this.questionData.splice(idx, 1)
                    this.$message({
                        message: '삭제되었습니다.',
                        type: 'success'
                    });
                    this.getList(this.page)
                }
            },
            async getList(page) {
                let resQuestionData = (await this.$http.get(`/api/questions/list?page=${page}`)).data
                this.questionData = resQuestionData.data
                this.listCount = resQuestionData.total
                this.page = page
                console.log(this.questionData)
            },
            async pagination(page) {
                await this.getList(page);
            },
            modifyQuestion(idx) {
                this.$router.push(`/maker?id=${idx}`)
            },
            async deleteChapter(id, idx) {
                if (confirm('정말 삭제하시겠습니까?')) {
                    await this.$http.post(`/api/chapters/delete`, {id: id})
                    this.chapterData.splice(idx, 1)
                    this.$message({
                        message: '삭제되었습니다.',
                        type: 'success'
                    });
                }
            },
            async modifyChapter(id, idx) {
                this.form = this.chapterData[idx];
                this.chapterStatus = '수정'
            },
            async createChapter() {
                let my_form = await this.$http.post(`/api/chapters/insert`, this.form)
                if (my_form['data']['message'] !== 'dup' && my_form['data']['message'] !== 'modified') {
                    console.log(my_form)
                    this.form.id = my_form['data'][0]
                    this.chapterData.push(this.form)
                    this.form = {
                        grade: 1,
                        semester: 1,
                        num: 1,
                        name: ''
                    }
                }
                if (my_form['data']['message'] === 'modified') {
                    this.$message({
                        message: '수정되었습니다.',
                        type: 'success'
                    });
                    this.chapterStatus = '생성'
                    this.form = {
                        grade: 1,
                        semester: 1,
                        num: 1,
                        name: ''
                    }
                }
                else
                    this.$message({
                        message: '중복되는 학년, 학기입니다.',
                        type: 'warning'
                    });
            }
        },
        watch: {
        },
        computed: mapGetters({
            token: "getToken",
            username: "getUsername"
        })
    }
</script>

<style>
    .article-list {
        max-width: 874px;
        text-align: center;
        display: inline-block;
        box-sizing: border-box;
        padding: 15px;
    }
    .article-container {
        width: 100%;
        text-align: center;
        margin: 0 auto;
        display: inline-block;
    }
    .article-title {
        width: 100%;
        border-bottom: 2px solid #bcbcbc;
        margin: 0 auto;
        display: inline-block;
    }
    .name-wrapper {
        float: left;
        line-height: 22px;
        letter-spacing: -1px;
        display: inline-block;
    }
    .name-wrapper > h3 {
        font-family: 나눔고딕,NanumGothic,system,sans-serif;
        font-size: 18px;
        font-weight: 600;
        color: #333;
    }
    .article-demonstrate {
        width: 100%;
        margin: 0 auto;
        display: inline-block;
    }
    .demonstration {
        display: list-item;
        text-align: -webkit-match-parent;
        margin-top: 10px;
        margin-bottom: 4px;
        color: #888;
        font-size: 12px;
        line-height: 15px;
        letter-spacing: -.3px;
        font-family: 나눔고딕,NanumGothic,system,sans-serif;
        list-style: none;
        float: left;
    }
    .article-table {
        width: 100%;
        margin: 30px auto;
        display: inline-block;
    }
    .pagination{
        display: inline-block;
        width: 880px;
    }
    .astext {
        background: none;
        border: none;
        margin: 0;
        padding: 0;
        cursor: pointer;
    }
    .write-buttons {
        width: 100%;
        margin: 0 auto;
        display: inline-block;
    }
    .write-buttons > button {
        float: right;
    }
</style>